export const payroll = {
  en: {
    previewTitle: "Preview a payslip",
    previewNote: "Shows what this person would be paid for the selected period. Nothing is saved until you generate.",
    generateThisOne: "Generate for this employee",
    item: "Item",
    amount: "Amount",
    title: "Payroll",
    payday: "Payday",
    paydaySet: "Announce payday",
    paydayUpdate: "Update payday",
    paydayHint: "Shown on every employee's calendar once saved. Changing it does not notify anyone who already saw the previous date.",
    removeItemTitle: "Remove this pay item?",
    removeItemBody: "This changes what the employee is paid for this period. The payroll run will be recalculated.",
    period: "Period",
    generate: "Generate payroll",
    generateSummaryCreated: "Created",
    generateSummarySkipped: "Skipped (already exists)",
    generateSummaryFailed: "Failed",
    generateResultEmployee: "Employee",
    generateResultStatus: "Status",
    generateResultReason: "Reason",
    generateStatusCreated: "Created",
    generateStatusSkipped: "Skipped",
    generateStatusFailed: "Failed",
    grossEarnings: "Gross earnings",
    deductions: "Deductions",
    netPay: "Net pay",
    deductionsExceededPay: "Deductions came to {amount} more than this month's earnings. Net pay cannot go below zero, so that amount was not taken.",
    employerCost: "Employer cost",
    statusDraft: "Draft",
    statusApproved: "Approved",
    statusPaid: "Paid",
    approve: "Approve",
    rebuild: "Rebuild from source data",
    loanRepaymentCombined: "Loan repayment",
    approveAll: "Approve all drafts",
    approveSelected: "Approve selected",
    approvingProgress: "Approving {done} of {total}…",
    approveFailed: "These could not be approved:",
    markPaid: "Mark as paid",
    reverse: "Reverse approval",
    reverseReason: "Why is this approval being reversed?",
    payslip: "Payslip",
    addItem: "Add a line",
    removeItem: "Remove line",
    earnings: "Earnings",
    prorated: "Prorated",
    bankTransferShort: "Bank",
    overtimeHours: "Hours",
    overtimeMinutes: "Minutes",
    overtimeAlready: "This run already has overtime:",
    addOvertimeFor: "Add overtime for {name}",
    reason: "Reason",
    perHour: "SAR / hour",
    overtimeOverridden: "This amount differs from the {computed} the contract works out to. It will be saved and marked as a manual override.",
    figuresStale: "Figures predate a change to the employment dates",
    deleteRunTitle: "Delete this payroll run",
    deleteRunBody: "{run} will be removed. A draft has paid nothing and consumed nothing, so nothing is reversed — it can be generated again.",
    startedOn: "Started {date}",
    lastDayOn: "Last day {date}",
    noRuns: "No payroll has been generated for this period yet.",
    totalNet: "Total net pay",
    otherEarnings: "Other allowances",
    gosi: "GOSI",
    loanDeduction: "Loans",
    prorationDeduction: "Unworked days",
    absenceDeduction: "Absence",
    otherDeductions: "Other deductions",
    totalsRow: "Total",
    employee: "Employee",
    paymentMethod: "Payment",
    mudad: "Mudad",
    bankTransfer: "Bank transfer",
    summary: "Payroll summary",
    totalPayroll: "Total payroll",
    totalMudad: "Total Mudad payments",
    totalBankTransfer: "Total bank transfer payments",
    exportExcel: "Export Excel",
    exportFailed: "Could not build the Excel file.",
  },
  ar: {
    previewTitle: "معاينة قسيمة راتب",
    previewNote: "يعرض ما سيتقاضاه هذا الموظف عن الفترة المحددة. لا يتم حفظ أي شيء حتى تقوم بالإنشاء.",
    generateThisOne: "إنشاء لهذا الموظف",
    item: "البند",
    amount: "المبلغ",
    title: "الرواتب",
    payday: "يوم صرف الرواتب",
    paydaySet: "الإعلان عن يوم الصرف",
    paydayUpdate: "تحديث يوم الصرف",
    paydayHint: "يظهر في تقويم كل موظف بعد الحفظ. تغييره لا يُشعر من رأى التاريخ السابق بالفعل.",
    removeItemTitle: "حذف هذا البند؟",
    removeItemBody: "سيؤدي هذا إلى تغيير صافي راتب الموظف لهذه الفترة، وسيُعاد احتساب مسير الرواتب.",
    period: "الفترة",
    generate: "إنشاء مسير الرواتب",
    generateSummaryCreated: "تم الإنشاء",
    generateSummarySkipped: "تم التخطي (موجود بالفعل)",
    generateSummaryFailed: "فشل",
    generateResultEmployee: "الموظف",
    generateResultStatus: "الحالة",
    generateResultReason: "السبب",
    generateStatusCreated: "تم الإنشاء",
    generateStatusSkipped: "تم التخطي",
    generateStatusFailed: "فشل",
    grossEarnings: "إجمالي المستحقات",
    deductions: "الاستقطاعات",
    netPay: "صافي الراتب",
    deductionsExceededPay: "تجاوزت الاستقطاعات أجر هذا الشهر بمقدار {amount}. لا يمكن أن يقل صافي الراتب عن صفر، لذلك لم يُستقطع هذا المبلغ.",
    employerCost: "تكلفة صاحب العمل",
    statusDraft: "مسودة",
    statusApproved: "معتمد",
    statusPaid: "مدفوع",
    approve: "اعتماد",
    rebuild: "إعادة البناء من البيانات المصدر",
    loanRepaymentCombined: "سداد السلف",
    approveAll: "اعتماد جميع المسودات",
    approveSelected: "اعتماد المحدد",
    approvingProgress: "جارٍ اعتماد {done} من {total}…",
    approveFailed: "تعذّر اعتماد هؤلاء:",
    markPaid: "تعليم كمدفوع",
    reverse: "التراجع عن الاعتماد",
    reverseReason: "ما سبب التراجع عن الاعتماد؟",
    payslip: "قسيمة الراتب",
    addItem: "إضافة بند",
    removeItem: "حذف البند",
    earnings: "المستحقات",
    prorated: "محتسب بالتناسب",
    bankTransferShort: "بنكي",
    overtimeHours: "ساعات",
    overtimeMinutes: "دقائق",
    overtimeAlready: "هذا المسير يحتوي بالفعل على عمل إضافي:",
    addOvertimeFor: "إضافة عمل إضافي لـ {name}",
    reason: "السبب",
    perHour: "ر.س/ساعة",
    overtimeOverridden: "هذا المبلغ يختلف عن {computed} المحسوب وفق العقد. سيُحفظ ويُوسم كتعديل يدوي.",
    figuresStale: "الأرقام سابقة لتعديل في تواريخ التوظيف",
    deleteRunTitle: "حذف مسير الرواتب",
    deleteRunBody: "سيُحذف {run}. المسودة لم تصرف شيئاً ولم تستهلك شيئاً، فلا يوجد ما يُعكس — ويمكن إنشاؤها من جديد.",
    startedOn: "باشر في {date}",
    lastDayOn: "آخر يوم عمل {date}",
    noRuns: "لم يتم إنشاء رواتب لهذه الفترة بعد.",
    totalNet: "إجمالي صافي الرواتب",
    otherEarnings: "بدلات أخرى",
    gosi: "التأمينات",
    loanDeduction: "السلف",
    prorationDeduction: "أيام غير مشمولة",
    absenceDeduction: "الغياب",
    otherDeductions: "استقطاعات أخرى",
    totalsRow: "الإجمالي",
    employee: "الموظف",
    paymentMethod: "طريقة الدفع",
    mudad: "مدد",
    bankTransfer: "تحويل بنكي",
    summary: "ملخص الرواتب",
    totalPayroll: "إجمالي الرواتب",
    totalMudad: "إجمالي مدفوعات مدد",
    totalBankTransfer: "إجمالي التحويلات البنكية",
    exportExcel: "تصدير إكسل",
    exportFailed: "تعذر إنشاء ملف إكسل.",
  },
} as const;
